import { actions, displayResponseError } from ".";
import api from "../api";

export const login = (emailAddress: string, password: string) => {
    return async (dispatch: (arg0: any) => void) => {
        try {
            let resLogin = await api.post("/api/login", { emailAddress, password });
            if (resLogin.status !== 200) {
                dispatch(displayResponseError(resLogin));
            }
            let resUserStatus = await api.get("/api/userstatus");
            dispatch(actions.updateUserStatusAction(resUserStatus.data));
            dispatch(actions.closeWindowAction({ name: "login" }));
        } catch (e) { }
    }
}

export const resetPassword = (emailAddress: string, code: string, password1: string, password2: string) => {
    return async (dispatch: (arg0: any) => void) => {
        try {
            let resLogin = await api.post(`/api/resetpassword/${code}`, { emailAddress, password1: password1, password2: password2 });
            if (resLogin.status !== 200) {
                dispatch(displayResponseError(resLogin));
            } else {
                alert("Password changed");
            }
            let resUserStatus = await api.get("/api/userstatus");
            dispatch(actions.updateUserStatusAction(resUserStatus.data));
        } catch (e) { }
    }
}

export const logout = () => {
    return async (dispatch: (arg0: any) => void) => {
        try {
            let resLogout = await api.post("/api/logout");
            let resUserStatus = await api.get("/api/userstatus");
            dispatch(actions.updateUserStatusAction(resUserStatus.data));
            dispatch(actions.closeWindowAction({ name: "user" }));
        } catch (e) { }
    }
}

export const fetchUserStatus = () => {
    return async (dispatch: (arg0: any) => void) => {
        try {
            let res = await api.get("/api/userstatus");
            dispatch(actions.updateUserStatusAction(res.data));
        } catch (e) { }
    }
}
